import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import emailjs from "@emailjs/browser";
import logo from "../../assets/images/logo-bg-si-min.png";
import { Modal, Button, Form, CloseButton } from "react-bootstrap";
import { Helmet } from "react-helmet";
import "./Contact.css";
import Loader from "../../components/loader/Loader";
import ReCAPTCHA from "react-google-recaptcha";

export default function ContactModal(props) {
  const [values, setValues] = useState({
    name: "",
    email: "",
    message: "",
    subject: "",
  });

  const [LoaderSpiner, setLoaderSpiner] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isVerifyRecap, setIsVerifyRecap] = useState(false);

  useEffect(() => {
    emailjs.init("3XXayTQASthFZgCy-");
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoaderSpiner(true);

    if (
      !values.name ||
      !values.email ||
      !values.subject ||
      values.message.length < 5
    ) {
      setLoaderSpiner(false);
      return; // Early return if validation fails
    }

    // Send email to admin
    const adminParams = {
      from_name: values.name,
      message: values.message,
      reply_to: values.email,
      subject: values.subject,
      to_name: "Bertrand",
    };

    emailjs
      .send("service_50wf07t", "template_pgfexyh", adminParams)
      .then((response) => {
        console.log("Email sent successfully:", response.text);
        setShowSuccess(true);
        setLoaderSpiner(false);
        setShowError(false);
        setValues({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
        setIsVerifyRecap(false);
      })
      .catch((error) => {
        console.error("Failed to send email:", error.text);
        setLoaderSpiner(false);
        setShowSuccess(false);
        setShowError(true);
      });

    // const userParams = {
    //   to_name: values.name,
    //   from_name: "BG Shooting Instruction",
    //   to_email: values.email,
    //   reply_to: "contact@bg-si.fr",
    //   subject: values.subject,
    //   message: values.message,
    // };

    // console.log("console log de userParams:", userParams);

    // emailjs
    //   .send("service_50wf07t", "template_q5ugpb9", userParams)
    //   .then((response) => {
    //     console.log("Auto-reply sent to user:", response.text);
    //     console.log("Success apres:", userParams);
    //   })
    //   .catch((error) => {
    //     console.error("Auto-reply error:", error.text);
    //     console.error("error apres :", userParams);
    //   });
  };

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  function handleOnChangeRecaptcha(value) {
    setIsVerifyRecap(Boolean(value));
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      variant="dark"
    >
      <Helmet>
        <title>Contact BG Shooting Instruction</title>
      </Helmet>
      <Modal.Header closeButton>
        <NavLink className="nav-link" to="/">
          <img
            src={logo}
            width="40"
            height="40"
            className="d-inline-block align-top"
            alt="BG Shooting Instruction"
          />
        </NavLink>
        <Modal.Title id="contained-modal-title-vcenter">
          Contact BG Instructor
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formBasicName">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter name"
              name="name"
              value={values.name}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email"
              name="email"
              value={values.email}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicSubject">
            <Form.Label>Select request type</Form.Label>
            <Form.Select
              name="subject"
              value={values.subject}
              onChange={handleChange}
            >
              <option value="">Select subject</option>
              <option value="Professionnelle">Security professional</option>
              <option value="TSV-IPSC">IPSC Athletes</option>
              <option value="Other">Other</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="message"
              value={values.message}
              onChange={handleChange}
            />
          </Form.Group>
          <div className="recaptcha-div">
            <ReCAPTCHA
              sitekey="6Ld7vyofAAAAADa5X42RHc-FTi09D3Xlp7lk3GCr"
              // sitekey="6Lfva88oAAAAANH0RHooeZfXkr_gCW0pR_UQY9TO"
              theme="dark"
              onChange={handleOnChangeRecaptcha}
            />
          </div>
          <div className="d-flex justify-content-center">
            <Button variant="primary" type="submit" disabled={!isVerifyRecap}>
              Send
            </Button>
          </div>
          {showSuccess && (
            <div className="success-message" style={{ position: "relative" }}>
              <CloseButton
                variant="white"
                onClick={() => setShowSuccess(false)}
                style={{
                  position: "absolute",
                  top: 5,
                  right: 10,
                }}
                aria-label="Close"
              />
              <p className="lead">Thank you!</p>
              <p>
                Your message has been successfully sent.
                <br />
                We will contact you very soon!
              </p>
            </div>
          )}
          {showError && (
            <div className="error-message" style={{ position: "relative" }}>
              <CloseButton
                variant="white"
                onClick={() => setShowError(false)}
                style={{
                  position: "absolute",
                  top: 5,
                  right: 10,
                }}
                aria-label="Close"
              />
              <p className="lead">Error</p>
              <p>
                An error occurred while sending your message.
                <br />
                Please try again later.
              </p>
            </div>

            // <div
            //   className="error-message"
            //   style={{
            //     position: "relative",
            //     backgroundColor: "#dc3545",
            //     color: "white",
            //     padding: "15px",
            //     marginTop: "15px",
            //     borderRadius: "5px",
            //   }}
            // >
            //   <CloseButton
            //     variant="white"
            //     onClick={() => setShowError(false)}
            //     style={{
            //       position: "absolute",
            //       top: 5,
            //       right: 10,
            //     }}
            //     aria-label="Close"
            //   />
            //   <p className="lead">Error</p>
            //   <p>
            //     An error occurred while sending your message.
            //     <br />
            //     Please try again later.
            //   </p>
            // </div>
          )}
          {LoaderSpiner && <Loader />}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={props.onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
